import React from 'react';

/**
 * Small uppercase tracked label — matches the design's `.eyebrow` recipe
 * (600 11/16, 0.08em tracking, fg-subtle by default).
 *
 *   <Eyebrow>Roadmap</Eyebrow>
 *   <h2>What's coming next</h2>
 *
 * Tones map to subtle (default) / muted / primary / success / warning /
 * error / brand. The spec uses `fg-subtle` — kept as the default.
 */
const TONES = {
  subtle: 'text-fg-subtle',
  muted: 'text-fg-muted',
  default: 'text-fg',
  primary: 'text-primary',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
  brand: 'text-brand',
};

export default function Eyebrow({
  tone = 'subtle',
  leadingIcon: LeadingIcon,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'inline-flex items-center gap-1.5 font-semibold uppercase tracking-eyebrow',
    'text-[11px] leading-4',
    TONES[tone] ?? TONES.subtle,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} {...rest}>
      {LeadingIcon ? <LeadingIcon className="w-3 h-3" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
